import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getClient } from '../client.routes';
import { ClientType } from '../types';

export function useGetClient(
  clientId: string | undefined,
  options?: Omit<
    UseQueryOptions<ClientType | null, AxiosError<unknown>, ClientType | null>,
    'queryKey' | 'queryFn'
  >,
) {
  return useQuery({
    queryKey: ['client', clientId],
    queryFn: () => getClient(clientId!),
    enabled: !!clientId,
    ...options,
  });
}
